/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import moment from 'moment';

import cleanUpResponse from '@/util/cleanUpResponse';
import { formatDisplayDate, format } from '@/util/MomentUtils';

export default async function CalculateDatesForOrder(orderId, popDate, piinSpiin) {
  // Format popDate
  if (!moment.isMoment(popDate)) popDate = moment(popDate);
  popDate = format(popDate, 'YYYY-MM-DD');

  const response = await $.soap({
    body: {
      CalculateDatesForOrder: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        OrderID: orderId,
        POPDate: popDate,
        PIINSPIIN: piinSpiin
      }
    },
    blueprint: {
      opSubmissionReqDate: '$..OPSubmissionReqDate',
      awSubmissionReqDate: '$..AWSubmissionReqDate',
      initialContactReqDate: '$..InitialContactReqDate'
    }
  });

  cleanUpResponse(response);

  if (response.opSubmissionReqDate) {
    response.opSubmissionReqDate = formatDisplayDate(response.opSubmissionReqDate, moment.ISO_8601);
  }
  if (response.awSubmissionReqDate) {
    response.awSubmissionReqDate = formatDisplayDate(response.awSubmissionReqDate, moment.ISO_8601);
  }
  if (response.initialContactReqDate) {
    response.initialContactReqDate = formatDisplayDate(response.initialContactReqDate, moment.ISO_8601);
  }

  return response;
}
